import { render, staticRenderFns } from "./About.html?vue&type=template&id=23600147&scoped=true&"
import script from "./About.js?vue&type=script&lang=js&"
export * from "./About.js?vue&type=script&lang=js&"
import style0 from "./About.scss?vue&type=style&index=0&id=23600147&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23600147",
  null
  
)

export default component.exports